export const AGGREGATIONS_CSV = {
  COUNT: 'COUNT',
  USERS: 'USERS',
  TOTAL: 'TOTAL',
  AVERAGE_TOTAL: 'AVERAGE_TOTAL',
  AVERAGE_TOTAL_SPLIT: 'AVERAGE_TOTAL_SPLIT',
  AVERAGE_COUNT: 'AVERAGE_COUNT',
  AVERAGE_COUNT_SPLIT: 'AVERAGE_COUNT_SPLIT',
  MAX: 'MAX',
  MIN: 'MIN',
};

export const PARAM_CSV = {
  HEADER: 'additionalHeader',
  GROUP_BY: 'groupBy',
  GROUP_BY_DAY: 'groupByDay',
  GROUP_BY_MS: 'groupByMs',
  SPLIT_BY: 'splitBy',
  SPLIT_BY_DAY: 'splitByDay',
  SPLIT_BY_MS: 'splitByMs',
  COUNT: 'count',
  SUM: 'sum',
  AVG_SUM: 'avgSum',
  MAX: 'max',
  MIN: 'min',
  AVG: 'avg',
  PERIODS: 'periods',
};

export const COLUMNS_CSV = {
  MS: 'millisecs: ',
  COUNT: 'count',
  TOTAL: 'total',
  AVG_TOTAL: 'average_total',
  MAX: 'max',
  MIN: 'min',
  AVG: 'avg (total/count)',
  AVERAGE_COUNT: 'average_count',
  AVERAGE_COUNT_SPLIT: 'average_count_split',
  USERS: 'users',
};

// используется для retention
export const UNITS_BY_TYPE = {
  DAILY: 'Day',
  WEEKLY: 'Week',
  MONTHLY: 'Month',
};

export const RETENTION_COLUMN = 'Users';

export const FIELDS_FULL_DATE = ['HOUR'];

export const CSV_FILE_DESCRIPTION = 'text/plain;charset=UTF-8';
